import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getPlatformCRMCardsOne, getPlatformCRMCardsTwo } from "./dashboard-platforms-section.utils";
import "./dashboard-platforms-section.scss";


const DashboardPlatformsSection: React.FC = () => {
    const navigate = useNavigate(); 
  const [platformCRMCardsOne, setPlatformCRMCardsOne] = useState<any>([]);
    const [platformCRMCardsTwo, setPlatformCRMCardsTwo] = useState<any>([]);

    const handlePathChange = (url: any) =>{ 
        if(url){
            navigate(url);
        }
  }

  useEffect(() => {
    const loginUserRolePermissions: any =JSON.parse(localStorage.getItem("loginData") || "{}")?.userDetails?.roles?.rolePermissions; 
        setPlatformCRMCardsOne(getPlatformCRMCardsOne(loginUserRolePermissions || []));
        setPlatformCRMCardsTwo(getPlatformCRMCardsTwo(loginUserRolePermissions || []));
  }, []);

  return (
    <div className="dashboard-platforms-section">
        <div className="dashboard-platforms-section-heading" >
            Do more with your CRM platform!
        </div>
        <div className="dashboard-platforms-section-row">
            {[...platformCRMCardsOne, ...platformCRMCardsTwo]?.map((data: any, index: any)=>{
               return  data?.isShowCard ? <div className="dashboard-platforms-section-row-cards" key={index}>
                <div className="dashboard-platforms-section-row-cards-heading-icon">
                       <div className={`dashboard-platforms-section-row-cards-icon ${data?.key === 'Templates & QRs' ? 'templates-and-qrs-icon' : `${data?.key?.toLowerCase().replace(/\s+/g, '-')}-icon` }`}>
                        <img src={data?.icon} alt="dashboardLeadManagement"/>
                    </div>
                    <div className="dashboard-platforms-section-row-cards-heading">
                        {data?.title}
                    </div>
                </div>
                {data?.sections?.map((subData: any, index: any)=>{
                        return subData?.isShowSubCard ?  <div className="dashboard-platforms-section-row-sub-cards"  onClick={() => handlePathChange(subData?.url)}>
                    <div className="dashboard-platforms-section-row-sub-cards-main-text">
                        {subData?.sectionsName}
                    </div>
                    <div className="dashboard-platforms-section-row-sub-cards-sub-text">
                       {subData?.sectionsText}
                    </div>
                </div> :""
                    })
                }
            </div>: ""
            })}
        </div>
    </div>
   
  );
};
export default DashboardPlatformsSection;